import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import events from 'lib/events';

class EditableCheckbox extends React.Component {
  static defaultProps = {
    editMode: true,
    disabled: false,
  };

  static propTypes = {
    children: PropTypes.any,
    class: PropTypes.string,
    dataKey: PropTypes.any,
    disabled: PropTypes.bool,
    editMode: PropTypes.bool.isRequired,
    hideLabel: PropTypes.bool,
    label: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
    withoutHangingIndent: PropTypes.bool,
    group: PropTypes.object,
    required: PropTypes.bool,
    validate: PropTypes.func,
    validateMessage: PropTypes.string,
  };

  state = {
    highlighted: false,
    validate: null,
    correct: true,
  };


  componentWillReceiveProps(nextProps) {
    // Validate when props change
    if (this.state.validate) {
      this.state.validate(nextProps.value);
    }
  }

  componentDidMount() {
    if (this.props.group) {
      this.props.group.addComponent(this);
    }
  }

  componentWillUnmount() {
    if (this.props.group) {
      this.props.group.removeComponent(this);
    }
  }


  focusHandler = () => {
    if (this.state.highlighted) {
      this.setState({
        highlighted: false,
      });
    }
  };

  handleChange = () => {
    if (!this.props.onChange) {
      return;
    }
    this.props.onChange({key: this.props.dataKey, value: !this.props.value});
    if (!this.state.correct) {
      this.validate(this.props.value);
    }
  };

  highlight = () => {
    this.setState({highlighted: true});
  };


  validate = (val = this.props.value) => {
    if (this.props.required && !val && val !== 0) {
      this.setState({
        correct: false,
      });

      if (this.props.validateMessage) {
        events.publish('error.user', {
          message: this.props.validateMessage,
          key: this.props.dataKey,
        });
      }

      return false;
    }

    if (!this.state.correct && this.props.required && (val || val === 0) && (!this.props.value || this.props.value === 0)) {
      this.setState({
        correct: true,
      });
      return true;
    }

    if (!this.props.validate) {
      this.setState({
        correct: true,
      });
      return true;
    }

    let validateResult = this.props.validate(val);

    if (validateResult === false) {
      this.setState({
        correct: false,
      });

      if (val && this.props.validateMessage) {
        events.publish('error.user', {
          message: this.props.validateMessage,
          key: this.props.dataKey,
        });
      }
      return false;
    }

    this.setState({correct: true});
    if(this.props.validateMessage) {
      events.publish('cancel.error', {key: this.props.dataKey});
    }
    return true;
  };

  focus = () => {
    if (this.refs.underlying) {
      this.refs.underlying.focus();
      this.refs.underlying.scrollIntoView(false);
    }
  };

  render() {
    let content = <i className={this.props.value ? 'bl bl-checkmark' : 'bl bl-x'} />;

    if (this.props.editMode) {
      content = <div className='checkbox-wrapper'>
        <input type='checkbox'
               disabled={this.props.disabled}
               id={(this.props.dataKey ? this.props.dataKey.toString() : '').replace('.', '-')}
               ref='underlying'
               checked={this.props.value}
               onChange={this.handleChange}
               data-event-category={this.props['data-event-category']}
               onFocus={this.focusHandler}
               data-event-action={this.props['data-event-action']} />
        <label />
      </div>;
    }

    let wrapperClass = 'editable-checkbox';

    if (this.props.class) {
      wrapperClass += ' ' + this.props.class;
    }

    let hangingIndent = this.props.withoutHangingIndent ?
    {
      marginLeft: -5,
    } :
    {
      paddingLeft: 35,
      textIndent: -40,
    };

    return (
      <div className={classNames(wrapperClass, {'error': !this.state.correct, 'form-control--highlighted': this.state.highlighted && this.props.editMode})}>
        <div className='form-control-static' style={this.props.editMode ? hangingIndent : {}}>
          <label className={classNames('editable-checkbox-blocklabel', {'edit-mode': this.props.editMode})}>
            {content}
            {!this.props.hideLabel ?
              <span className='editable-checkbox-label' >
                {this.props.label ? this.props.label : this.props.children}
              </span> : null}
          </label>
        </div>
      </div>
    );
  }
}

export default EditableCheckbox;
